export const DASHBOARD = {
  GRIDCOLUMNS_dashboard_heatmapSummaryDetail_all: 'GRIDCOLUMNS_dashboard_heatmapSummaryDetail_all',
  GRIDCOLUMNS_dashboard_heatmapSummaryDetail_application:
    'GRIDCOLUMNS_dashboard_heatmapSummaryDetail_application',
  GRIDCOLUMNS_dashboard_heatmapSummaryDetail_clickhouse:
    'GRIDCOLUMNS_dashboard_heatmapSummaryDetail_clickhouse',
  GRIDCOLUMNS_dashboard_heatmapSummaryDetail_altibase:
    'GRIDCOLUMNS_dashboard_heatmapSummaryDetail_altibase',
  GRIDCOLUMNS_dashboard_heatmapSummaryDetail_mysql:
    'GRIDCOLUMNS_dashboard_heatmapSummaryDetail_mysql',
  GRIDCOLUMNS_dashboard_heatmapSummaryDetail_oracle:
    'GRIDCOLUMNS_dashboard_heatmapSummaryDetail_oracle',
  GRIDCOLUMNS_dashboard_heatmapSummaryDetail_postgresql:
    'GRIDCOLUMNS_dashboard_heatmapSummaryDetail_postgresql',
  GRIDCOLUMNS_dashboard_heatmapSummaryDetail_redis:
    'GRIDCOLUMNS_dashboard_heatmapSummaryDetail_redis',
  GRIDCOLUMNS_dashboard_heatmapSummaryDetail_redshift:
    'GRIDCOLUMNS_dashboard_heatmapSummaryDetail_redshift',
  GRIDCOLUMNS_dashboard_heatmapSummaryDetail_sqlserver:
    'GRIDCOLUMNS_dashboard_heatmapSummaryDetail_sqlserver',
  GRIDCOLUMNS_dashboard_heatmapSummaryDetail_tibero:
    'GRIDCOLUMNS_dashboard_heatmapSummaryDetail_tibero',
  GRIDCOLUMNS_dashboard_scatterSummaryDetail_all: 'GRIDCOLUMNS_dashboard_scatterSummaryDetail_all',
  GRIDCOLUMNS_dashboard_scatterSummaryDetail_application:
    'GRIDCOLUMNS_dashboard_scatterSummaryDetail_application',
  GRIDCOLUMNS_dashboard_scatterSummaryDetail_clickhouse:
    'GRIDCOLUMNS_dashboard_scatterSummaryDetail_clickhouse',
  GRIDCOLUMNS_dashboard_scatterSummaryDetail_altibase:
    'GRIDCOLUMNS_dashboard_scatterSummaryDetail_altibase',
  GRIDCOLUMNS_dashboard_scatterSummaryDetail_mysql:
    'GRIDCOLUMNS_dashboard_scatterSummaryDetail_mysql',
  GRIDCOLUMNS_dashboard_scatterSummaryDetail_oracle:
    'GRIDCOLUMNS_dashboard_scatterSummaryDetail_oracle',
  GRIDCOLUMNS_dashboard_scatterSummaryDetail_postgresql:
    'GRIDCOLUMNS_dashboard_scatterSummaryDetail_postgresql',
  GRIDCOLUMNS_dashboard_scatterSummaryDetail_redis:
    'GRIDCOLUMNS_dashboard_scatterSummaryDetail_redis',
  GRIDCOLUMNS_dashboard_scatterSummaryDetail_redshift:
    'GRIDCOLUMNS_dashboard_scatterSummaryDetail_redshift',
  GRIDCOLUMNS_dashboard_scatterSummaryDetail_sqlserver:
    'GRIDCOLUMNS_dashboard_scatterSummaryDetail_sqlserver',
  GRIDCOLUMNS_dashboard_scatterSummaryDetail_tibero:
    'GRIDCOLUMNS_dashboard_scatterSummaryDetail_tibero',
  GRIDCOLUMNS_dashboard_scatterSummaryDetail_custom:
    'GRIDCOLUMNS_dashboard_scatterSummaryDetail_custom',
  GRIDCOLUMNS_dashboard_scatterSummaryDetailPrometheus:
    'GRIDCOLUMNS_dashboard_scatterSummaryDetailPrometheus',
  GRIDCOLUMNS_dashboard_metricSummaryDetail: 'GRIDCOLUMNS_dashboard_metricSummaryDetail',
  GRIDCOLUMNS_dashboard_currentStatSlideDetail: 'GRIDCOLUMNS_dashboard_currentStatSlideDetail',
  FILTERSEARCH_dashboard_scatterSummaryDetail_all:
    'FILTERSEARCH_dashboard_scatterSummaryDetail_all',
  FILTERSEARCH_dashboard_scatterSummaryDetail_application:
    'FILTERSEARCH_dashboard_scatterSummaryDetail_application',
  FILTERSEARCH_dashboard_scatterSummaryDetail_clickhouse:
    'FILTERSEARCH_dashboard_scatterSummaryDetail_clickhouse',
  FILTERSEARCH_dashboard_scatterSummaryDetail_altibase:
    'FILTERSEARCH_dashboard_scatterSummaryDetail_altibase',
  FILTERSEARCH_dashboard_scatterSummaryDetail_mysql:
    'FILTERSEARCH_dashboard_scatterSummaryDetail_mysql',
  FILTERSEARCH_dashboard_scatterSummaryDetail_oracle:
    'FILTERSEARCH_dashboard_scatterSummaryDetail_oracle',
  FILTERSEARCH_dashboard_scatterSummaryDetail_postgresql:
    'FILTERSEARCH_dashboard_scatterSummaryDetail_postgresql',
  FILTERSEARCH_dashboard_scatterSummaryDetail_redis:
    'FILTERSEARCH_dashboard_scatterSummaryDetail_redis',
  FILTERSEARCH_dashboard_scatterSummaryDetail_redshift:
    'FILTERSEARCH_dashboard_scatterSummaryDetail_redshift',
  FILTERSEARCH_dashboard_scatterSummaryDetail_sqlserver:
    'FILTERSEARCH_dashboard_scatterSummaryDetail_sqlserver',
  FILTERSEARCH_dashboard_scatterSummaryDetail_tibero:
    'FILTERSEARCH_dashboard_scatterSummaryDetail_tibero',
  FILTERSEARCH_dashboard_scatterSummaryDetailPrometheus:
    'FILTERSEARCH_dashboard_scatterSummaryDetailPrometheus',
  FILTERSEARCH_dashboard_scatterSummaryDetail_custom:
    'FILTERSEARCH_dashboard_scatterSummaryDetail_custom',
  GRIDCOLUMNS_dashboard_topologySummaryDetail: 'GRIDCOLUMNS_dashboard_topologySummaryDetail',
  GRIDCOLUMNS_dashboard_tableWidget_global: 'GRIDCOLUMNS_dashboard_tableWidget_global',
  GRIDCOLUMNS_dashboard_tableWidget_user: 'GRIDCOLUMNS_dashboard_tableWidget_user',
  GRIDCOLUMNS_dashboard_treeGridWidget_global: 'GRIDCOLUMNS_dashboard_treeGridWidget_global',
  GRIDCOLUMNS_dashboard_treeGridWidget_user: 'GRIDCOLUMNS_dashboard_treeGridWidget_user',
  GRIDSETTINGS_dashboard_treeGridWidget_global: 'GRIDSETTINGS_dashboard_treeGridWidget_global',
  GRIDSETTINGS_dashboard_treeGridWidget_user: 'GRIDSETTINGS_dashboard_treeGridWidget_user',
  GRIDCOLUMNS_dashboard_dashboardList: 'GRIDCOLUMNS_dashboard_dashboardList',
  GRIDCOLUMNS_dashboard_shareWindow_userList: 'GRIDCOLUMNS_dashboard_shareWindow_userList',
  SEVERITY_dashboard_hexagonWidget_global: 'SEVERITY_dashboard_hexagonWidget_global',
  SEVERITY_dashboard_hexagonWidget_user: 'SEVERITY_dashboard_hexagonWidget_user',
  ALERTFILTER_dashboard_alertWidget_global: 'ALERTFILTER_dashboard_alertWidget_global',
  ALERTFILTER_dashboard_alertWidget_user: 'ALERTFILTER_dashboard_alertWidget_user',
  GRIDSETTINGS_dashboard_alertTableWidget_global: 'GRIDSETTINGS_dashboard_alertTableWidget_global',
  GRIDSETTINGS_dashboard_alertTableWidget_user: 'GRIDSETTINGS_dashboard_alertTableWidget_user',
  POSITIONS_dashboard_topologyWidget_global: 'POSITIONS_dashboard_topologyWidget_global',
  POSITIONS_dashboard_topologyWidget_user: 'POSITIONS_dashboard_topologyWidget_user',
  POSITIONS_dashboard_topologyPointMapWidget_global:
    'POSITIONS_dashboard_topologyPointMapWidget_global',
  POSITIONS_dashboard_topologyPointMapWidget_user:
    'POSITIONS_dashboard_topologyPointMapWidget_user',
  VIEWPORT_dashboard_topologyPointMapWidget_global:
    'VIEWPORT_dashboard_topologyPointMapWidget_global',
  VIEWPORT_dashboard_topologyPointMapWidget_user: 'VIEWPORT_dashboard_topologyPointMapWidget_user',
  VIEWPORT_dashboard_topologyWidget_global: 'VIEWPORT_dashboard_topologyWidget_global',
  VIEWPORT_dashboard_topologyWidget_user: 'VIEWPORT_dashboard_topologyWidget_user',
  IS_LOCKED_dashboard_topologyPointMapWidget_global:
    'IS_LOCKED_dashboard_topologyPointMapWidget_global',
  IS_LOCKED_dashboard_topologyPointMapWidget_user:
    'IS_LOCKED_dashboard_topologyPointMapWidget_user',
  IS_LOCKED_dashboard_topologyWidget_global: 'IS_LOCKED_dashboard_topologyWidget_global',
  IS_LOCKED_dashboard_topologyWidget_user: 'IS_LOCKED_dashboard_topologyWidget_user',
  POSITIONS_dashboard_clusterWidget_global: 'POSITIONS_dashboard_clusterWidget_global',
  POSITIONS_dashboard_clusterWidget_user: 'POSITIONS_dashboard_clusterWidget_user',
  STAT_dashboard_clusterWidget_user: 'STAT_dashboard_clusterWidget_user',
  IS_LOCKED_dashboard_clusterWidget_user: 'IS_LOCKED_dashboard_clusterWidget_user',
  AUTOALIGN_dashboard_topologyWidget_global: 'AUTOALIGN_dashboard_topologyWidget_global',
  AUTOALIGN_dashboard_topologyWidget_user: 'AUTOALIGN_dashboard_topologyWidget_user',
  FILTERVALUES_dashboard_filterWidget_user: 'FILTERVALUES_dashboard_filterWidget_user',
  FILTERSEARCH_dashboard_dashboardList: 'FILTERSEARCH_dashboard_dashboardList',
  FILTERSEARCH_dashboard_tableWidget: 'FILTERSEARCH_dashboard_tableWidget',
  FILTERSEARCH_dashboard_treeGridWidget: 'FILTERSEARCH_dashboard_treeGridWidget',
  FILTERSEARCH_dashboard_shareWindow_userList: 'FILTERSEARCH_dashboard_shareWindow_userList',
  SELECTEDGROUP_dashboard_dashboardList: 'SELECTEDGROUP_dashboard_dashboardList',
  FILTERSEARCH_dashboard_alertTableWidget: 'FILTERSEARCH_dashboard_alertTableWidget',
  DISPLAYOPTION_dashboard_main_view: 'DISPLAYOPTION_dashboard_main_view',
  LEGEND_dashboard_global: 'LEGEND_dashboard_global',
  LEGEND_dashboard_user: 'LEGEND_dashboard_user',
  EXTERNAL_prometheus_metric_filter_search: 'EXTERNAL_prometheus_metric_filter_search',
  EXTERNAL_prometheus_metric_column: 'EXTERNAL_prometheus_metric_column',
  ALERTHIGHLIGHT_dashboard_user: 'ALERTHIGHLIGHT_dashboard_user',
  OPTIONS_dashboard_scatterWidget_user: 'OPTIONS_dashboard_scatterWidget_user',
  GRIDCOLUMNS_dashboard_equalizerGroupSummaryDetail:
    'GRIDCOLUMNS_dashboard_equalizerGroupSummaryDetail',
  FILTERSEARCH_dashboard_equalizerGroupSummaryDetail:
    'FILTERSEARCH_dashboard_equalizerGroupSummaryDetail',
  GRIDCOLUMNS_dashboard_statusSummaryDetail: 'GRIDCOLUMNS_dashboard_statusSummaryDetail',
  FILTERSEARCH_dashboard_statusSummaryDetail: 'FILTERSEARCH_dashboard_statusSummaryDetail',
  GLOBAL_VARIABLE_FILTER_dashboard_user: 'GLOBAL_VARIABLE_FILTER_dashboard_user',
} as const;
